/** @format */

import { createAction } from 'redux-actions';
import types from './types';
import { resetCreateMeetupStatus } from '../navbar/action';

export const toggleUseAppModal = createAction(
	types.TOGGLE_USE_APP_MODAL,
	() => (dispatch, getState) => {
		const { ui } = getState();
		if (ui) {
			dispatch(resetCreateMeetupStatus());
		}
		return { isOpen: !ui.useAppModal };
	}
);

export const toggleExtraMeetupModal = createAction(
	types.TOGGLE_EXTRA_MEETUP_MODAL,
	() => (dispatch, getState) => {
		const { ui } = getState();
		if (ui) {
			dispatch(resetCreateMeetupStatus());
		}
		return { isOpen: !ui.extraMeetupModal };
	}
);

export const toggleProfileModifyModal = createAction(
	types.TOGGLE_PROFILE_MODIFY_MODAL,
	() => (_, getState) => {
		const { ui } = getState();
		return { isOpen: !ui.useAppModal };
	}
);

export const toggleRightSidebar = createAction(
	types.TOGGLE_RIGHT_SIDEBAR_MODAL,
	(toggle) => (_, getState) => {
		return { isOpen: toggle };
	}
);

export const toggleAlertModal = createAction(
	types.TOGGLE_ALERT_MODAL,
	(toggle, type) => (dispatch, getState) => {
		const { ui } = getState();
		return {
			isOpen: toggle,
			type: type ? type : ui.alertModal.type
		};
	}
);

export const toggleShareModal = createAction(
	types.TOGGLE_SHARE_MODAL,
	(toggle, copy) => (dispatch, getState) => {
		const { ui } = getState();
		return {
			isOpen: toggle,
			copy: copy ? copy : ui.shareModal.copy
		};
	}
);
